import { createSharedComposable } from '@vueuse/core'
import { ref } from 'vue'

// Lifecycle-bound shared state: created lazily when App (or any caller) starts
// and disposed when the last subscriber unmounts. This keeps the fatal-error
// state scoped to the running app instead of surviving as a module-level
// singleton across multiple Vue apps or test mounts.
export const useErrorHandler = createSharedComposable(() => {
  const fatalError = ref<unknown>(null)

  return {
    fatalError,
    setFatalError: (err: unknown) => {
      fatalError.value = err
    },
    clearFatalError: () => {
      fatalError.value = null
    }
  }
})

/**
 * Show a fallback error page when Vue/Router is not available
 * This is used by global error handlers in main.ts when the app crashes
 */
export function showFallbackErrorPage() {
  document.body.innerHTML = `
    <div style="display: flex; align-items: center; justify-content: center; min-height: 100vh; font-family: sans-serif; background: #f5f5f5; padding: 2rem;">
      <div style="text-align: center; background: white; padding: 3rem 2rem; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.1); max-width: 600px;">
        <div style="margin-bottom: 2rem;">
          <svg viewBox="0 0 100 100" style="width: 100px; height: 100px; margin: 0 auto; display: block;">
            <circle cx="50" cy="50" r="45" fill="#FEE2E2" />
            <circle cx="50" cy="50" r="35" fill="#FCA5A5" />
            <path d="M50 30 L50 55" stroke="#DC2626" stroke-width="4" stroke-linecap="round" />
            <circle cx="50" cy="67" r="3" fill="#DC2626" />
          </svg>
        </div>
        <h1 style="color: #DC2626; font-size: 2rem; margin-bottom: 1rem; font-weight: 600;">Oops! Something went wrong</h1>
        <p style="color: #666; font-size: 1.125rem; line-height: 1.6;">The issue has been reported, and we're working to fix it as quickly as possible. Please try again later.</p>
      </div>
    </div>
  `
}
